import { createElement } from 'react';
import { ItemTypes } from '../Constants';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';
import { store, ScreenComponentProps, ComponentDesc, ShelfComponentProps } from '../store';
import { observer } from 'mobx-react';
import withStyles from 'react-jss';

import MarginEditor from './common/MarginEditor';
import PaddingEditor from './common/PaddingEditor';
import BorderEdit from './common/BorderEdit';
import BackgroundColorPicker from './common/BackgroundColorPicker';
import ColorPicker from './common/ColorPicker';
import Typograph from './common/Typograph';
import TextAlign from './common/TextAlign';
import BoxShadow from './common/BoxShadow';
import BorderRadius from './common/BorderRadius';
import { settingsComponentStyles, shelfComponentStyles } from './common/styles';
import { flowRight } from 'lodash';
import TextDecoration from './common/TextDecoration';

const svg = require('./icons/header.svg');
//const menu_button = require('./icons/menu_button.svg');

interface TitleSettings {
    text: string;
}

let defaultTemplate = {
    type: 'TITLE',
    style: {
        marginRight: 0,
        marginLeft: 0,
        marginBottom: 0,
        marginTop: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        textAlign: 'center',
        color: '#000000',
        backgroundColor: '#D5EFF6',
        fontSize: 30,
        fontFamily: 'Helvetica',
        borderWidth: 1,
        borderStyle: 'Solid',
        borderColor: '#373D49',
    },
    settings: {
        text: 'Title...',
    },
    name: 'Title',
};

let shelfComponent = flowRight([
    withStyles(shelfComponentStyles),
    DragSource(
        ItemTypes.COMPONENT,
        {
            beginDrag(props, monitor, component): ComponentDesc<TitleSettings> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        (connect: DragSourceConnector, monitor: DragSourceMonitor) => {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.section}>
                <img src={svg} className={classes.icon} />
                <span className={classes.label}>Title</span>
            </div>
        </div>
    );
});

function ScreenComponent({ connectDragSource, isDragging, descriptor }: ScreenComponentProps<TitleSettings>) {
    return (
        <div
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move',
                minHeight: '10px',
                // border: '1px solid black',
            }}
            onClick={(e) => store.selectComponent(descriptor)}>
            {' '}
            <h1 style={{ ...descriptor.style }}>{descriptor.settings.text}</h1>
        </div>
    );
}

/**
 * Define the settings panel for this component
 * @type {({ descriptor }: any) => any}
 */

const SettingsComponent = flowRight([withStyles(settingsComponentStyles), observer])(({ descriptor, classes }: any) => {
    return (
        <div>
            <div className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        marginBottom: 10,
                        alignItems: 'center',
                        paddingTop: 10,
                    }}>
                    <span className={classes.header} style={{ width: 102 }}>
                        Name
                    </span>
                    <input type="text" value={descriptor.settings.text} onChange={(e) => (descriptor.settings.text = e.target.value)} className={classes.src} style={{ width: 179 }} />
                </div>
            </div>
            <div>
                <TextAlign descriptor={descriptor} />
                <Typograph descriptor={descriptor} />
                <TextDecoration descriptor={descriptor} />
                <BoxShadow descriptor={descriptor} />
                <MarginEditor descriptor={descriptor} />
                <PaddingEditor descriptor={descriptor} />
                <BorderEdit descriptor={descriptor} />
                <BackgroundColorPicker descriptor={descriptor} />
                <ColorPicker descriptor={descriptor} />
            </div>
        </div>
    );
});

store.registerComponent({
    name: 'TITLE',
    type: 'component',
    shelfComponent: shelfComponent,
    screenComponent: observer(ScreenComponent),
    settingsComponent: SettingsComponent,
    defaultTemplate,
    svg,
});

//export default component;
